import { ContextualField } from '../../../models/ContextualField';
import { PropertyType } from '../../../models/enum';

export const GroupGuids: ContextualField = {
    modelName: 'groupGuids',
    propertyType: PropertyType.MultiGroup,
    icon: 'fa-sitemap',
    label: 'Groups',
    propertyName: 'groupGuidsProperty',
    extraData: {
    }
};